import BioComponent from '../bio/BioComponent'
import BooksComponent from '../books/BooksComponent'
import './home.css'
const HomeComponent = () => {

    return (
      <>
        <div className="heroSection">
          <div className="overlayContent">
              <div className="bookCovers">
              <a href='#The Clio Project Bundle'><img alt="The Clio Project Bundle" src="images/BUNDLE.jpg" className="heroBook" /></a>
              <a href='#The Clio Project'><img alt="The Clio Project" src="images/CLIO_PROJECT_COVER.jpg" className="heroBook" /></a>
              <a href='#Operation Ameliorate'><img alt="Operation Ameliorate" src="images/OPERATION_AMELIORATE_BOOK2_FRONT.jpg" className="heroBook" /></a>
              <a href='#Recoveries'><img alt="Recoveries" src="images/RECOVERIES.png" className="heroBook" /></a>
              </div>
              <p className="heroTagline">
              Exciting tales of United States Air Force members traveling through time.
              </p>
          </div>
        </div>
        <br/>
        <BooksComponent></BooksComponent>
        <BioComponent></BioComponent>
      </>
    )
}

export default HomeComponent
